import React from 'react';
import { ProfilePage } from './ProfilePage';

export function SocialProfilePage() {
  return <ProfilePage />;
}
